module.exports = __webpack_public_path__ + "img/bull.bcfc9fb4.png";